export default "__VITE_ASSET__Z_TS_zRO__"